import { component } from "picoapp";

export default component(async (node, ctx) => {
  const [{ default: KeenSlider }] = await Promise.all([
    import("keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const sliderElement = node.querySelector("[data-mobile-slider]");
  const slides = node.querySelectorAll("[data-mobile-slide]");
  const sliderPrevElement = node.querySelector("[data-prev]");
  const sliderNextElement = node.querySelector("[data-next]");

  const mobileSlider = KeenSlider(sliderElement, {
    defaultAnimation: {
      duration: 800,
    },
    selector: slides,
    loop: true,
    created: (instance) => {
      initNavigation();
      node.classList.remove("hide-init");
    },
  });

  function initNavigation() {
    sliderPrevElement.addEventListener("click", () => {
      mobileSlider.prev();
    });

    sliderNextElement.addEventListener("click", () => {
      mobileSlider.next();
    });
  }

  ctx.on("window:resize", () => {
    if (window.innerWidth < 750) {
      mobileSlider.update(mobileSlider.options, mobileSlider.track.details.abs);
      ctx.emit("product-card:updateAll", { productCard: { device: "mobile" } });
    }
  });
});
